import { ICellRendererParams } from '@ag-grid-community/core';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { getCurrencyAmount } from '@tassat/ag-grid';
import { AssetTypes, OrderSide, TransactionTypeChar } from '@tassat/common-definitions';
import { CollateralHistoryViewRecord } from '@tassat/fred-definitions';
import { AssetTicker, TransactionHistoryRecord } from '@tassat/fred-extended-definitions';
import { formatAsAsset } from '@tassat/utility';
import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getAssetFromTicker } from 'Selectors/assets';

interface FormatAssetsAmountProps extends ICellRendererParams {
    currencyDisplayType?: 'curcode' | 'symbol';
    data: TransactionHistoryRecord | CollateralHistoryViewRecord;
    hideAsset?: boolean;
}

const muiStyles = makeStyles({
    cell: { fontSize: '13px' },
    boldAmount: { fontWeight: 'bold' }
});

export const FormatAssetsAmount = (props: FormatAssetsAmountProps) => {
    const {
        currencyDisplayType = 'curcode',
        data,
        hideAsset,
        colDef
    } = props;
    const { isCollateral = false } = colDef?.cellRendererParams ?? {};

    const asset = useAppSelector((state) => getAssetFromTicker(state, props.data?.Ticker));
    const currency = useAppSelector((state) => getAssetFromTicker(state, AssetTicker.USD));

    if (!asset) return <></>;

    const classes = muiStyles();
    const isCurrencyAsset = asset.Type === AssetTypes.CURRENCY;
    const showSecurityAmount = !hideAsset && asset.Type === AssetTypes.ASSET;
    const completedIntDist = (
        (data as TransactionHistoryRecord).type === TransactionTypeChar.int_distribution && (data as TransactionHistoryRecord).IsCompleted
    );

    const currencyAmount = getCurrencyAmount(asset, data);
    const hidePendingWord = (data as TransactionHistoryRecord).IsCompleted &&
        ((data as TransactionHistoryRecord).type === TransactionTypeChar.order && (
            (data as TransactionHistoryRecord).OrderSide === OrderSide.REDEEM ||
            (data as TransactionHistoryRecord).OrderSide === OrderSide.SUBSCRIPTION
        )) ||
        (((data as TransactionHistoryRecord).type === TransactionTypeChar.send || (data as TransactionHistoryRecord).type === TransactionTypeChar.transfer) && (data as TransactionHistoryRecord).FiatAmount == '0');

    return (
        <Grid
            container
            direction='column'
        >
            {!isCurrencyAsset && (showSecurityAmount || completedIntDist) ?
                (
                    !isCollateral ?
                        <Typography
                            className={`${classes.boldAmount} ${classes.cell}`}
                        >{data?.AssetQuantity ?
                                formatAsAsset(data.AssetQuantity, asset, 'ticker', undefined, true)
                                : `${asset.Ticker} ${hidePendingWord ? '-' : 'Pending'}`}
                        </Typography>
                        : (
                            <Typography
                                className={`${classes.boldAmount} ${classes.cell}`}
                            >{data?.Amount ?
                                    formatAsAsset(data.Amount, asset, 'ticker', undefined, true)
                                    : `${asset.Ticker} ${hidePendingWord ? '-' : '0'}`}
                            </Typography>
                        )
                )
                : null}
            {!isCollateral &&
                (
                <Typography
                    className={classes.cell}
                >
                    {
                        currencyAmount || completedIntDist ?
                            formatAsAsset(currencyAmount, {
                                ...currency,
                                DecimalPoint: 2
                            }, currencyDisplayType)
                            : `${currency.Curcode} ${hidePendingWord ? '-' : 'Pending'}`
                    }
                </Typography>
            )}
        </Grid>
    );
};

export default FormatAssetsAmount;